import userPhoto1 from '../assets/instructorsPhoto/1.jpg';
import userPhoto2 from '../assets/instructorsPhoto/2.jpg';
import userPhoto3 from '../assets/instructorsPhoto/3.jpg';
import userPhoto4 from '../assets/instructorsPhoto/4.jpg';
import userPhoto5 from '../assets/instructorsPhoto/5.jpg';
import userPhoto6 from '../assets/instructorsPhoto/6.jpg';
import userPhoto7 from '../assets/instructorsPhoto/7.jpg';
import userPhoto8 from '../assets/instructorsPhoto/8.jpg';
import userPhoto9 from '../assets/instructorsPhoto/9.jpg';

export const chat = [
    {
        id: 1000,
        name: 'Sophia Slessor',
        photo: userPhoto1,
        titleOption: 'unclear about a concept question',
        likes: 17,
        text: 'Jeepers illicit yikes far orca including smooched where or crud next beside censor',
        date: 'Saturday at 08:51 AM ET',
        comments: [
            {
                id: 321,
                name: 'Jack Phillips',
                photo: userPhoto2,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 3221,
                name: 'Angela Puffer',
                photo: userPhoto3,
                text: 'Well wow stopped unwound legitimate less the and more alongside at instantaneously against opposite darn the consoled oh rode yikes but fractious so far much forgot gurgled undertook blew hey humorously much hound the cantankerously',
                date: 'Thursday at 01:55 AM ET',
            },
            {
                id: 3241,
                name: 'Zinah Shalhoub',
                photo: userPhoto4,
                text: 'Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 31221,
                name: 'Jack Phillips',
                photo: userPhoto5,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            }
        ]
    },
    {
        id: 24589,
        name: 'Lois Copelan',
        photo: userPhoto2,
        titleOption: 'unclear about a concept question',
        likes: 3,
        text: 'Jeepers illicit yikes far orca including smooched where or crud next beside censor',
        date: 'Thursday at 08:51 AM ET',
        comments: [
            {
                id: 76543,
                name: 'Jack Phillips',
                photo: userPhoto3,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 5678908765,
                name: 'Angela Puffer',
                photo: userPhoto4,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Thursday at 01:55 AM ET',
            },
            {
                id: 876,
                name: 'Zinah Shalhoub',
                photo: userPhoto5,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 3456,
                name: 'Jack Phillips',
                photo: userPhoto6,
                text: 'Those an equal point no years do. Depend warmth fat but her but played. Shy and subjects wondered trifling pleasant. Prudent cordial comfort do no on colonel as assured chicken. Smart mrs day which begin. Snug do sold mr it if such. Terminer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            }
        ]
    },
    {
        id: 10,
        name: 'Angela Puffer',
        photo: userPhoto3,
        titleOption: 'unclear about a concept question',
        likes: 10,
        text: 'JThose an equal point no years do. Depend warmth fat but her but played. Shy and subjects wondered trifling pleasant. Prudent cordial comfort do no on colonel as assured chir orca including smooched where or crud next beside censor',
        date: 'Saturday at 08:51 AM ET',
        comments: [
            {
                id: 76542,
                name: 'Alice Bourget',
                photo: userPhoto4,
                text: 'Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 876543,
                name: 'Jack Phillips',
                photo: userPhoto5,
                text: 'Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 87654,
                name: 'Zinah Shalhoub',
                photo: userPhoto4,
                text: 'f meant. Death means up civil do an offer wound of.eath means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            }
        ]
    },
    {
        id: 202,
        name: 'Sophia Slessor',
        photo: userPhoto4,
        titleOption: 'unclear about a concept question',
        likes: 1,
        text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound o',
        date: 'Monday at 04:51 AM ET',
        comments: [
            {
                id: 345689,
                name: 'Jack Phillips',
                photo: userPhoto2,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 567,
                name: 'Angela Puffer',
                photo: userPhoto3,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            }
        ]
    },
    {
        id: 30,
        name: 'Sophia Slessor',
        photo: userPhoto5,
        titleOption: 'unclear about a concept question',
        likes: 2,
        text: 'Well wow stopped unwound legitimate less the and more alongside at instantaneously against opposite darn the consoled oh rode yikes but fractious so far much forgot gurgled undertook blew hey humorously much hound the cantankerously crud the thanksde censor',
        date: 'Saturday at 08:51 AM ET',
        comments: [
            {
                id: 478,
                name: 'Yseult Noëls',
                photo: userPhoto6,
                text: 'Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 483221,
                name: 'Angela Puffer',
                photo: userPhoto7,
                text: 'Well wow stopped unwound legitimate less the and more alongside at instantaneously against opposite darn the consoled oh rode yikes but fractious so far much forgot gurgled undertook blew hey humorously much hound the cantankerously crud the thanks Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 4009,
                name: 'Jack Phillips',
                photo: userPhoto8,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 40,
                name: 'Alice Bourget',
                photo: userPhoto5,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 4009,
                name: 'Zinah Shalhoubs',
                photo: userPhoto9,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 40,
                name: 'Jack Phillips',
                photo: userPhoto5,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            }
        ]
    },
    {
        id: 3000,
        name: 'Alice Bourget',
        photo: userPhoto6,
        titleOption: 'unclear about a concept question',
        likes: 3,
        text: 'Jeepers illicit yikes far orca including smooched where or crud next beside censor',
        date: 'Saturday at 08:51 AM ET',
        comments: [
            {
                id: 3200,
                name: 'Yseult Noël',
                photo: userPhoto9,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 3300,
                name: 'Zinah Shalhoub',
                photo: userPhoto3,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 3400,
                name: 'Jack Phillips',
                photo: userPhoto8,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            },
            {
                id: 31221,
                name: 'Alice Bourget',
                photo: userPhoto5,
                text: 'Unpleasant astonished an diminution up partiality. Noisy an their of meant. Death means up civil do an offer wound of. Called square an in afraid direct. Resolution diminution conviction so mr at unpleasing simplicity no. No it as breakfast up conv',
                date: 'Monday at 01:55 AM ET',
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/data/discussion.js